<template>
  <div>
    <v-tabs v-model="strTab" centered icons-and-text>
      <v-tab href="#tab-cadastro">
        Cadastro Geral
        <i :class="$utilidade.getIcone('cadastroGeral') + ' fa-2x'"></i>
      </v-tab>
    </v-tabs>

    <ed-form
      :formData="formData"
      :handlerSave="salvar"
      v-if="!this.$root.$session.loadingContent && boolCarregado"
    >
      <cadastro-geral
        :formData="formData"
        v-show="strTab == 'tab-cadastro'"
        :key="'cadastro-' + $root.$session.versao"
      />
    </ed-form>
  </div>
</template>

<script>
import { EdForm } from "@/components/common/form";

import CadastroGeral from "./partials/geral.vue";

export default {
  name: "pageCadastroFuncao",
  props: {
    intId: {
      type: [Number, String],
      required: false,
      default: null,
    },
  },
  components: {
    EdForm,
    CadastroGeral,
  },
  mounted() {
    this.getAudiometro();
  },
  created() {},
  data() {
    return {
      strTab: "tab-cadastro",
      boolCarregado: false,
      formData: {
        intId: 0,
        strNome: null,
        strModelo: null,
        strFabricante: null,
        intTempoAfericao: 12,
        intTempoCalibragem: 12,
        strDataUltimaAfericao:null,
        strDataUltimaCalibragem:null,
      },
    };
  },
  watch: {
    intCidId() {
      this.getAudiometro();
    },
  },
  methods: {
    getAudiometro() {
      if (!this.intId) {
        this.boolCarregado = true;
        return;
      }

      this.$root.$dialog.loading(true);

      this.$root.$request
        .get("Audiometria/Audiometro", { intId: this.intId })
        .then((objResponse) => {
          this.$root.$dialog.loading(false);

          if (objResponse.status == 200) {
            this.formData = Object.assign(objResponse.result, {});
          }

          this.boolCarregado = true;
        });
    },

    salvar() {
      this.$root.$request.post("Audiometria/Audiometro", this.formData).then((objResponse) => {
        if (objResponse.status == 200) {
          if (this.$route.name != "audiometria.audiometro.edit") {
            this.$router.push({
              name: "audiometria.audiometro.edit",
              params: { intId: objResponse.result.intId },
            });
          } else {
            this.getAudiometro();
          }
        }
      });
    },
  },
};
</script>
